import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roleSelect", "orgSelect", "teamSection", "teamSelect", "hmSection"]

  connect() {
    this.roleChanged()
    this.orgChanged()
  }

  roleChanged() {
    if (!this.hasHmSectionTarget) return

    const role = this.roleSelectTarget.value
    if (role === "hiring_manager") {
      this.hmSectionTarget.classList.remove("hidden")
    } else {
      this.hmSectionTarget.classList.add("hidden")
    }
  }

  orgChanged() {
    if (!this.hasTeamSectionTarget) return

    const orgId = this.orgSelectTarget.value
    if (orgId) {
      this.teamSectionTarget.classList.remove("hidden")
      this.fetchTeams(orgId)
    } else {
      this.teamSectionTarget.classList.add("hidden")
      this.resetTeamSelect()
    }
  }

  async fetchTeams(orgId) {
    try {
      const response = await fetch(`/admin/users/teams_for_org?organization_id=${orgId}`)
      const teams = await response.json()

      this.resetTeamSelect()
      // Build options as DOM nodes so team names are set via textContent,
      // preventing HTML injection from attacker-controlled team names.
      teams.forEach(team => {
        this.teamSelectTarget.add(new Option(team.name, team.id))
      })
    } catch (error) {
      this.resetTeamSelect()
    }
  }

  resetTeamSelect() {
    this.teamSelectTarget.replaceChildren(new Option("No team", ""))
  }
}
